import React from "react";
import classes from "./SkillCircle.module.css";
import emojy9 from "../../assets/images/emojy/emojy9.png";

const SkillCircle = () => {
  return (
    <div className={classes["skill-circle-box"]}>
      <div
        className={`${classes["skill-circle"]} ${classes["skill-circle-01"]}`}
      ></div>
      <div
        className={`${classes["skill-circle"]} ${classes["skill-circle-02"]}`}
      ></div>
      <div
        className={`${classes["skill-circle"]} ${classes["skill-circle-03"]}`}
      ></div>

      <div
        className={`${classes["skill-circle"]} ${classes["skill-circle-04"]}`}
      ></div>
      <div
        className={`${classes["skill-circle"]} ${classes["skill-circle-05"]}`}
      ></div>
      <div className={`${classes["skill-img-box"]}`}>
        <img src={emojy9} />
      </div>
      <ul className={`${classes["skill-circle-list"]}`}>
        <li className={`${classes["skill-circle-item"]} ${classes["html"]}`}>
          HTML
        </li>
        <li className={`${classes["skill-circle-item"]} ${classes["css"]}`}>
          CSS
        </li>
        <li
          className={`${classes["skill-circle-item"]} ${classes["javascript"]}`}
        >
          JAVASCRIPT
        </li>
        <li className={`${classes["skill-circle-item"]} ${classes["react"]}`}>
          REACT.js
        </li>
        <li className={`${classes["skill-circle-item"]} ${classes["next"]}`}>
          NEXT.js
        </li>
        <li className={`${classes["skill-circle-item"]} ${classes["java"]}`}>
          JAVA
        </li>
        <li className={`${classes["skill-circle-item"]} ${classes["spring"]}`}>
          SPRING
        </li>
      </ul>
    </div>
  );
};

export default SkillCircle;
